import { render, staticRenderFns } from "./favouriteMatchesSection.vue?vue&type=template&id=563d7668&"
import script from "./favouriteMatchesSection.vue?vue&type=script&lang=js&"
export * from "./favouriteMatchesSection.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports